import styled from "styled-components";

export const DispatchPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const InnerPageWrapper = styled.div`
  width: 100%;
  background: #f8f8f8;
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  padding-bottom: 140px;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
`;

export const DispatchButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  background: #000;
  width: 100%;
  padding: 20px;
  max-width: 500px;
  margin: 0 auto;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
  z-index: 200;
`;
